<template>
  <su-page>
    <div slot="content">
      <div class="align-center mtb30">
        <div class="f24 cl000 font-bold">{{ details.title }}</div>
        <div class="cl666 f12 mt15">发布时间: {{ details.date }}</div>
      </div>
      <div class="mb15" style="min-height: 10vh">
        <el-row style="line-height: 30px" v-html="details.content"></el-row>
        <el-row v-if="details.video">
          <play-video :src="details.video"></play-video>
        </el-row>
        <div class="f14 mt20">
          <a v-if="details.pdf_file" :href="details.pdf_file" target="_blank">点击下载附件</a>
        </div>
      </div>
      <div class="borderTop pt30 flex al-cn ju-cn">
        <div class="flex al-cn" v-if="!details.is_collct" @click="favoriteArticle">
          <i class="el-icon-star-off f28 mr5"></i>
          收藏
        </div>
        <div class="flex al-cn" v-else @click="unfavoriteArticle">
          <i class="el-icon-star-on clC32912 f32 mr5"></i>
          已收藏
        </div>
      </div>
    </div>
    <div slot="bottom" class="pageSwitching">
      <div class="su-card p20 flex al-cn mt20" @click="previousPost">
        <el-row v-if="details.pre_id" class="cl999 f14 mr20" style="min-width: 45px;">上一篇</el-row>
        <el-row class="pageSwitching-item">{{ details.pre_id ? details.pre_title : details.title }}</el-row>
      </div>
      <div class="su-card p20 flex al-cn mt20" @click="nextPost">
        <el-row v-if="details.next_id" class="cl999 f14 mr20" style="min-width: 45px;">下一篇</el-row>
        <el-row class="pageSwitching-item">{{ details.next_id ? details.next_title : details.title }}</el-row>
      </div>
    </div>
  </su-page>
</template>
<script>

import PlayVideo from "@/components/play-video/play-video.vue";
import {mapState} from "vuex";

export default {
  components: {PlayVideo},
  props: {
    details: {
      type: Object,
      default: () => {
      }
    },
  },
  data() {
    return {
      showVideo: false,
      fileName: '',
    }
  },
  computed: {
    ...mapState(['token', 'userInfo']),
  },
  mounted() {

  },
  methods: {
    favoriteArticle() {
      if (!this.token) {
        this.$message.warning('请先登录')
        return
      }
      this.$emit('favoriteArticle')
    },
    unfavoriteArticle() {
      if (!this.token) {
        this.$message.warning('请先登录')
        return
      }
      this.$emit('unfavoriteArticle')
    },
    // 上一篇
    previousPost() {
      if (!this.details.pre_id) {
        this.$message.warning('已经是第一篇了')
        return
      }
      this.$emit('previousPost', this.details.pre_id)
    },
    // 下一篇
    nextPost() {
      if (!this.details.next_id) {
        this.$message.warning('已经是最后一篇了')
        return
      }
      this.$emit('nextPost', this.details.next_id)
    }
  }
}
</script>

<style scoped lang="scss">
@media (min-width: 750px) {
  .pageSwitching {
    grid-column-gap: 15px;
    display: grid;
    grid-template-columns: calc(50% - 7px) calc(50% - 7px);

    &-item {
      //只显示一行内容超出加..."
      overflow: hidden;
      text-overflow: ellipsis;
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      white-space: normal;

      &:hover {
        cursor: pointer;
        background: #f5f5f5;
      }
    }
  }
}
</style>
